import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  dataContainer: {
    padding: theme.spacing(1),
  },
  dataTable: {
    marginBottom: theme.spacing(2),
  },
}))

export default styles
